import { useEffect, useState } from 'react'
import { useCompactorStore } from '../store/compactor'

const RESULT_VISIBLE_MS = 10_000

/** Bottom-right pill shown while the background cache compactor runs, with
 *  a brief "freed N MB" result after it finishes. Purely informational —
 *  compaction never blocks the UI and never deletes media. */
export function CompactionToast() {
  const { running, phase, tier, done, total, freedBytes, finishedAt, warning } =
    useCompactorStore()
  const [showResult, setShowResult] = useState(false)

  useEffect(() => {
    if (finishedAt == null) return
    setShowResult(true)
    const t = setTimeout(() => setShowResult(false), RESULT_VISIBLE_MS)
    return () => clearTimeout(t)
  }, [finishedAt])

  if (!running && !showResult) return null

  const mb = (n: number) =>
    n >= 1024 * 1024 * 1024
      ? `${(n / 1024 / 1024 / 1024).toFixed(1)} GB`
      : `${(n / 1024 / 1024).toFixed(0)} MB`

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 max-w-xs">
      <div className="rounded-xl border border-white/15 bg-black/80 px-3 py-2 text-[12px] text-ink-100 shadow-lg backdrop-blur">
        {running ? (
          <div className="flex items-center gap-2">
            <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-sky-400 border-t-transparent" />
            <span>
              compressing image cache{tier > 1 ? ` (pass ${tier})` : ''}…{' '}
              <strong className="text-white">
                {total > 0 ? `${done.toLocaleString()} / ${total.toLocaleString()}` : ''}
              </strong>{' '}
              <span className="text-ink-400">({phase})</span>
            </span>
          </div>
        ) : warning ? (
          <div className="text-amber-300">⚠ {warning}</div>
        ) : (
          <div className="text-emerald-300">
            ✓ image cache compressed{freedBytes != null && freedBytes > 0 ? ` — freed ${mb(freedBytes)}` : ''}
          </div>
        )}
      </div>
    </div>
  )
}
